module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-tablet-738x57@2x.19d13ed6.jpg";